export const INFO_ALREADY_PROCESSED_ERR_MSG = 'User has no right to finish task.';

export const dialogs = {
	processedTasks: 'processInformation/processedTasks',
	userDoesntHavePermissions: 'processInformation/userDoesntHavePermissions',
	userCanProcessMax10Tasks: 'processInformation/userCanProcessMax10Tasks',
};
